export default __webpack_public_path__ + "static/media/minun-hoitoni-darkblue.9a2a978a.svg";